import { Brush } from '@finsim/charts';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $timeRange, timeRangeChanged } from '../../../entities/view-settings';
import { Button } from '../../../shared/ui';
import { scenarioColor } from '../lib/series';
import type { CanvasData } from './use-canvas';

/** Time-range brush shared by every view (zoom persists across views and is kept in the URL). */
export function RangeBar({ data }: { data: CanvasData }) {
  const { t } = useTranslation();
  const [range, setRange] = useUnit([$timeRange, timeRangeChanged]);
  const { result, focused, focusedResult, dates, fmt } = data;
  if (!focused || !focusedResult || result.months < 24) return null;
  const last = result.months - 1;
  return (
    <div className="z-10 flex shrink-0 items-center gap-3 border-t border-border-subtle bg-bg-0 px-4 py-2">
      <span className="shrink-0 text-xs text-text-3">{t('charts.range')}</span>
      <div className="min-w-0 flex-1">
        <Brush
          length={result.months}
          values={focusedResult.series.netWorth.nominal}
          color={scenarioColor(focused)}
          range={range ?? [0, last]}
          onChange={(next) => {
            setRange(next[0] === 0 && next[1] === last ? null : next);
          }}
          startLabel={t('charts.rangeStart')}
          endLabel={t('charts.rangeEnd')}
          formatIndex={(i) => (dates[i] ? fmt.monthLong(dates[i]) : '')}
          height={36}
        />
      </div>
      <Button
        size="sm"
        variant="ghost"
        disabled={range === null}
        onClick={() => {
          setRange(null);
        }}
      >
        {t('charts.resetRange')}
      </Button>
    </div>
  );
}
